import 'public-path';
import $ from 'cash-dom';

import AccountController from 'controllers/AccountController';
import AccountRegistrationController from 'controllers/AccountRegistrationController';
import CareersPageController from 'controllers/CareersPageController';
import ContentHubPageController from 'controllers/ContentHubPageController';
import NotFoundPageContainer from 'controllers/NotFoundController';
import OurCommitmentController from 'controllers/OurCommitmentController';
import ReturnsController from 'controllers/ReturnsController';
import SearchPageController from 'controllers/SearchPageController';
import StayInTouchController from 'controllers/StayInTouchController';
import ApplicationEntrypoint from 'entrypoints/ApplicationEntrypoint';
import store from 'state';

class GeneralEntrypoint extends ApplicationEntrypoint {
  static async init() {
    await super.init(store);

    if (GeneralEntrypoint.matches('OurCommitment')) {
      OurCommitmentController.init(store);
    } else if (GeneralEntrypoint.matches('ReturnsPage')) {
      ReturnsController.init(store);
    } else if (GeneralEntrypoint.matches('CareersPage')) {
      CareersPageController.init(store);
    } else if (GeneralEntrypoint.matches('login-register')) {
      AccountRegistrationController.init(store);
    } else if (GeneralEntrypoint.matches('StayInTouch')) {
      StayInTouchController.init(store);
    } else if (GeneralEntrypoint.matches('account-management')) {
      AccountController.init(store);
    } else if (GeneralEntrypoint.matches('SearchPage')) {
      SearchPageController.init(store);
    } else if (GeneralEntrypoint.matches('ContentHubPage')) {
      ContentHubPageController.init(store);
    } else if (GeneralEntrypoint.matches('not-found')) {
      NotFoundPageContainer.init(store);
    }
  }
}

/* istanbul ignore next */
$(document).ready(async () => {
  await GeneralEntrypoint.init();
  GeneralEntrypoint.removeLoader();
});

export default GeneralEntrypoint;
